export default {
  welcomeScreen: {
    text1: 'Hi',
    text2: 'My name is',
    text3: 'Welcome to today’s class.'
  },
  checklistScreen: {
    text1: 'Before we begin',
    text2: 'let us check if we have all the materials for class.',
    checklistData: {
      text1: 'A4 Sheets and Sketching pad',
      text2: 'Pencil and Eraser',
      text3: 'Sketchpens',
      text4: 'Crayons',
      text5: 'Comfortably seated'
    }
  },
  classSummaryScreen: {
    text1: 'In today’s class, we will',
    summary: {
      text1: 'Choose a theme',
      text2: 'Pick a character',
      text3: 'Draw the character'
    }
  },
  themeSelectorScreen: {
    text1: 'Choose a theme'
  },
  characterSelectorScreen: {
    text1: 'Choose a'
  },
  referenceScreen: {
    text1: 'Reference'
  },
  afterClassSummaryScreen: {
    text1: 'Hi, today we',
    text2: 'Chose a theme',
    text3: 'Chose a character from the theme',
    text4: 'Practiced drawing chosen character'
  },
  nextClassSummaryScreen: {
    text1: 'Next class we will,',
    text2: 'Choose new characters',
    text3: 'Learn how to draw them'
  },
  primaryFeedbackScreen: {
    text1: 'What did you enjoy the most in today’s class?',
    text2: 'Choosing a theme',
    text3: 'Picking the character',
    text4: 'Drawing the character'
  },
  secondaryFeedbackScreen: {
    text1: 'What did you find difficult in today’s class?',
    text2: 'Choosing a theme',
    text3: 'Picking the character',
    text4: 'Drawing the character'
  }
}